module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/whatsapp-badge-nocolor-3fb169c7c61d8c8ae9485ad4ddbd791c.svg";